// const API_URL = process.env.API_URL || ''

// For local development uncomment below code
const configs = JSON.parse(sessionStorage.getItem("configs"));


const isOnEnv = (env) => {
  const domain = typeof window !== "undefined" ? window.location.origin : "";
  return domain.split(".")[0].indexOf(env) !== -1;
};

const getRoutingKey = () =>{
  if (isOnEnv("localhost") || isOnEnv("127") || isOnEnv("it1") || isOnEnv("it2")) {
    return  configs?.IT_TEST_ROUTE_KEY || 'it2';
  }
  if(isOnEnv("uat1") || isOnEnv("uat2")){
    return  configs?.UAT_TEST_ROUTE_KEY || 'uat2';
  }
  const domain = typeof window !== "undefined" ? window.location.origin : "";
  const key = domain.replace("https://", "").split("-")[0];
  return key;
};

const isProd = () => {
  const domain = typeof window !== "undefined" ? window.location.host : "";
  return domain.indexOf("docmanagement") === 0;
};

const accessOrigin = () => {
  let origin = "";
  const domain = typeof window !== "undefined" ? window.location.origin : "";
  const dns = domain.substring(
    domain.lastIndexOf(".", domain.lastIndexOf(".") - 1) + 1
  );

  if (dns === "bank-dns.com") {
    origin = "internal";
  } else if (dns === "usbank.com") {
    origin = "external";
  } else {
    origin = "internal";
  }
  return origin;
};

const defaultEndpoints = {
  apigee: "https://it-api.usbank.com",
  // apigee:"https://it1-usb-digital-api-common.us.bank-dns.com",
  // envUrl: "http://localhost:8090",
  envUrl: "https://it1-docmanagement.us.bank-dns.com",
  termsofuse: "https://content.usbank.com",
  api: "https://it1-docmanagement.us.bank-dns.com",
  // manageUser:
  //   "https://it4-onlinebanking.usbank.com/digital/servicing/ui/customer-profile",
  // myProfile:
  //   "https://it4-onlinebanking.usbank.com/digital/servicing/ui/customer-profile/my-profile",
  authCodeUrl: "https://it-sso.us.bank-dns.com",
  redirect: "http://localhost:8080",

  manifestPath:
  "https://it2-onlinebanking.usbank.com/auth/login/wmf/latest/manifest.json",
manifestPathTimeout:
  "https://it3-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
manifestPathLoginHelp:
  "https://it2-onlinebanking.usbank.com/digital/loginhelp/wmf/latest/manifest.json",
  
  transmit: accessOrigin() === "internal" ? 'https://it1-transec.usbank.com' : "/Proxy/TS",
  servicingAPI:"https://it-api.usbank.com/document-management/coreservice/user-management/v1/cdcservice/graphql",
  // servicingAPI: "https://it1-usb-digital-api-common.us.bank-dns.com/digital/servicing/customer-mgmt-cdc/retrievals/graphql",
  updateCredentialsApi:
    "https://it-api.usbank.com/authentication/customer-auth/credentials/v1/reset",
  createCredentialsApi:
    "https://it-api.usbank.com/authentication/customer-auth/credentials/v1/create",
  configApiURL:
    "https://it-api.usbank.com/authentication/customer-auth/app-config/v1/config",
  configAK: "zV2JDobreS0n3GBzU7fhgbN6toHArF6v",
  routingKey: "it4",
  authRoutingKey: "it4",
};

const setEndpointURLs = () => {
  let transmitUrl = "";
  let redirectUrl = "";
  if (isOnEnv("localhost") || isOnEnv("127")) {
    return defaultEndpoints;
  }

  if (isOnEnv("dev01")) {
    return {
      apigee:"https://it1-usb-digital-api-common.us.bank-dns.com",
      envUrl: "https://it1-docmanagement.us.bank-dns.com",
      termsofuse: "https://content.usbank.com",
      api: "https://it1-docmanagement.us.bank-dns.com",
      // manageUser:
      //   "https://dev5-digital-servicing-api.us.bank-dns.com/digital/servicing/ui/customer-profile",
      authCodeUrl: "https://it-sso.us.bank-dns.com",
      transmit: accessOrigin() === "internal" ? 'https://it1-transec.usbank.com' : "/Proxy/TS",
      redirect: "https://dev01-docmgmt.us.bank-dns.com",
      servicingAPI:"https://it1-usb-digital-api-common.us.bank-dns.com/digital/servicing/customer-mgmt-cdc/retrievals/graphql",
      manifestPath:
        "https://it2-onlinebanking.usbank.com/auth/login/wmf/latest/manifest.json",
      manifestPathTimeout:
        "https://it3-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
      manifestPathLoginHelp:
        "https://it2-onlinebanking.usbank.com/digital/loginhelp/wmf/latest/manifest.json",
      updateCredentialsApi:
        "https://it-api.usbank.com/authentication/customer-auth/credentials/v1/reset",
      createCredentialsApi:
        "https://it-api.usbank.com/authentication/customer-auth/credentials/v1/create",
      configApiURL:
        "https://it-api.usbank.com/authentication/customer-auth/app-config/v1/config",
      routingKey: getRoutingKey(),
      routingUpdateKey: getRoutingKey(),
      authRoutingKey: getRoutingKey(),
    };
  }

  if (isOnEnv("it1")) {
    if (accessOrigin() === "internal") {
      transmitUrl = "https://it1-transec.usbank.com";
      redirectUrl = "https://it1-docmanagement.us.bank-dns.com";
    } else if (accessOrigin() === "external") {
      transmitUrl = "/Proxy/TS";
      redirectUrl = "https://it1-docmanagement.usbank.com";
    }

    return {
      apigee: "https://it-api.usbank.com",
      envUrl: "https://it1-docmanagement.us.bank-dns.com",
      api: redirectUrl,
      termsofuse: "https://it2-content.usbank.com",
      // manageUser:
      //   "https://it1-onlinebanking.usbank.com/digital/servicing/ui/customer-profile",
      // myProfile:
      //   "https://it1-onlinebanking.usbank.com/digital/servicing/ui/customer-profile/my-profile",
      authCodeUrl: "https://it-sso.us.bank-dns.com",
      redirect: redirectUrl,
      transmit: transmitUrl,
      manifestPath:
        "https://it2-onlinebanking.usbank.com/auth/login/wmf/latest/manifest.json",
      manifestPathTimeout:
        "https://it3-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
      manifestPathLoginHelp:
        "https://it2-onlinebanking.usbank.com/digital/loginhelp/wmf/latest/manifest.json",
      servicingAPI: "https://it-api.usbank.com/document-management/coreservice/user-management/v1/cdcservice/graphql",
      // servicingAPI: "https://it1-usb-digital-api-common.us.bank-dns.com/digital/servicing/customer-mgmt-cdc/retrievals/graphql",
      updateCredentialsApi:
        "https://it-api.usbank.com/authentication/customer-auth/credentials/v1/reset",
      createCredentialsApi:
        "https://it-api.usbank.com/authentication/customer-auth/credentials/v1/create",
      configApiURL:
        "https://it-api.usbank.com/authentication/customer-auth/app-config/v1/config",
      configAK: "zV2JDobreS0n3GBzU7fhgbN6toHArF6v",
      routingKey: getRoutingKey(),
      routingUpdateKey: getRoutingKey(),
      authRoutingKey: getRoutingKey(),
    };
  }


  if (isOnEnv("it2")) {
    if (accessOrigin() === "internal") {
      transmitUrl = "https://it1-transec.usbank.com";
      redirectUrl = "https://it2-docmanagement.us.bank-dns.com";
    } else if (accessOrigin() === "external") {
      transmitUrl = "/Proxy/TS";
      redirectUrl = "https://it2-docmanagement.usbank.com";
    }

    return {
      apigee: "https://it-api.usbank.com",
      envUrl: "https://it1-docmanagement.us.bank-dns.com",
      api: "https://it1-docmanagement.us.bank-dns.com",
      termsofuse: "https://it2-content.usbank.com",
      // manageUser:
      //   "https://it1-onlinebanking.usbank.com/digital/servicing/ui/customer-profile",
      // myProfile:
      //   "https://it1-onlinebanking.usbank.com/digital/servicing/ui/customer-profile/my-profile",
      authCodeUrl: "https://it-sso.us.bank-dns.com",
      redirect: redirectUrl,
      transmit: transmitUrl,
      manifestPath:
        "https://it2-onlinebanking.usbank.com/auth/login/wmf/latest/manifest.json",
      manifestPathTimeout:
        "https://it3-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
      manifestPathLoginHelp:
        "https://it2-onlinebanking.usbank.com/digital/loginhelp/wmf/latest/manifest.json",
      servicingAPI:"https://it-api.usbank.com/document-management/coreservice/user-management/v1/cdcservice/graphql",
      // servicingAPI: "https://it1-usb-digital-api-common.us.bank-dns.com/digital/servicing/customer-mgmt-cdc/retrievals/graphql",
      updateCredentialsApi:
        "https://it-api.usbank.com/authentication/customer-auth/credentials/v1/reset",
      createCredentialsApi:
        "https://it-api.usbank.com/authentication/customer-auth/credentials/v1/create",
      configApiURL:
        "https://it-api.usbank.com/authentication/customer-auth/app-config/v1/config",
      configAK: "zV2JDobreS0n3GBzU7fhgbN6toHArF6v",
      routingKey: getRoutingKey(),
      routingUpdateKey: getRoutingKey(),
      authRoutingKey: getRoutingKey(),
    };
  }


  if (isOnEnv("uat1")) {
    if (accessOrigin() === "internal") { // contains -dns in the domain
      transmitUrl = "https://uat1-transec.usbank.com";
      redirectUrl = "https://uat1-docmanagement.us.bank-dns.com";
    } else if (accessOrigin() === "external") { // does not contain -dns in the domain
      transmitUrl = "/Proxy/TS";
      redirectUrl = "https://uat1-docmanagement.usbank.com";
    }

    return {
      apigee: "https://alpha-api.usbank.com",
      envUrl: "https://uat1-docmanagement.us.bank-dns.com",
      // envUrl: "https://perf1-usb-digital-api-common-cbc.us.bank-dns.com",
      api: redirectUrl,
      termsofuse: "https://uat1-content.usbank.com",
      // manageUser:
      //   "https://uat3-onlinebanking.usbank.com/digital/servicing/ui/customer-profile",
      // myProfile:
      //   "https://uat3-onlinebanking.usbank.com/digital/servicing/ui/customer-profile/my-profile",
      authCodeUrl: "https://uat-sso.us.bank-dns.com",
      redirect: redirectUrl,
      transmit: transmitUrl,
      servicingAPI: "https://alpha-api.usbank.com/document-management/coreservice/user-management/v1/cdcservice/graphql",
      updateCredentialsApi:
        "https://alpha-api.usbank.com/authentication/customer-auth/credentials/v1/reset",
      createCredentialsApi:
        "https://alpha-api.usbank.com/authentication/customer-auth/credentials/v1/create",
      configApiURL:
        "https://alpha-api.usbank.com/authentication/customer-auth/app-config/v1/config",
      configAK: "G6Fl3fdtwBEJXTF8WBFmyLF3xTJO3NiU",
      routingKey: getRoutingKey(),
      routingUpdateKey: getRoutingKey(),
      authRoutingKey: getRoutingKey(),
      manifestPath:
        "https://uat2-onlinebanking.usbank.com/auth/login/wmf/latest/manifest.json",
      manifestPathTimeout:
        "https://uat3-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
      manifestPathLoginHelp:
      "https://uat2-onlinebanking.usbank.com/digital/loginhelp/wmf/latest/manifest.json",
    };
  }

  if (isOnEnv("uat2")) {
    if (accessOrigin() === "internal") { // contains -dns in the domain
      transmitUrl = "https://uat1-transec.usbank.com"; 
      redirectUrl = "https://uat2-docmanagement.us.bank-dns.com";
    } else if (accessOrigin() === "external") { // does not contain -dns in the domain
      transmitUrl = "/Proxy/TS";
      redirectUrl = "https://uat2-docmanagement.usbank.com";
    }

    return {
      apigee: "https://alpha-api.usbank.com",
      envUrl: "https://uat1-docmanagement.us.bank-dns.com",
      // envUrl: "https://perf1-usb-digital-api-common-cbc.us.bank-dns.com",
      api: "https://uat1-docmanagement.us.bank-dns.com",
      termsofuse: "https://uat1-content.usbank.com",
      // manageUser:
      //   "https://uat3-onlinebanking.usbank.com/digital/servicing/ui/customer-profile",
      // myProfile:
      //   "https://uat3-onlinebanking.usbank.com/digital/servicing/ui/customer-profile/my-profile",
      authCodeUrl: "https://uat-sso.us.bank-dns.com",
      redirect: redirectUrl,
      transmit: transmitUrl,
      servicingAPI:"https://alpha-api.usbank.com/document-management/coreservice/user-management/v1/cdcservice/graphql",
      updateCredentialsApi:
        "https://alpha-api.usbank.com/authentication/customer-auth/credentials/v1/reset",
      createCredentialsApi:
        "https://alpha-api.usbank.com/authentication/customer-auth/credentials/v1/create",
      configApiURL:
        "https://alpha-api.usbank.com/authentication/customer-auth/app-config/v1/config",
      configAK: "G6Fl3fdtwBEJXTF8WBFmyLF3xTJO3NiU",
      routingKey: getRoutingKey(),
      routingUpdateKey: getRoutingKey(),
      authRoutingKey: getRoutingKey(),
      manifestPath:
        "https://uat2-onlinebanking.usbank.com/auth/login/wmf/latest/manifest.json",
      manifestPathTimeout:
        "https://uat3-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
      manifestPathLoginHelp:
      "https://uat2-onlinebanking.usbank.com/digital/loginhelp/wmf/latest/manifest.json",
    };
  }



  if (isProd()) {
    if (accessOrigin() === "internal") {
      transmitUrl = "https://transec.usbank.com";
      redirectUrl = "https://docmanagement.us.bank-dns.com";
    } else if (accessOrigin() === "external") {
      transmitUrl = "/Proxy/TS";
      redirectUrl = "https://docmanagement.usbank.com";
    }

    return {
      apigee: "https://api.usbank.com",
      envUrl: "https://docmanagement.usbank.com",
      api: redirectUrl,
      termsofuse: "https://content.usbank.com",
      // manageUser:
      //   "https://onlinebanking.usbank.com/digital/servicing/ui/customer-profile",
      // myProfile:
      //   "https://onlinebanking.usbank.com/digital/servicing/ui/customer-profile/my-profile",
      authCodeUrl: "https://sso.us.bank-dns.com",
      redirect: redirectUrl,
      transmit: transmitUrl,
      servicingAPI: "https://api.usbank.com/document-management/coreservice/user-management/v1/cdcservice/graphql",

      updateCredentialsApi:
        "https://api.usbank.com/authentication/customer-auth/credentials/v1/reset",
      createCredentialsApi:
        "https://api.usbank.com/authentication/customer-auth/credentials/v1/create",
      configApiURL:
        "https://api.usbank.com/authentication/customer-auth/app-config/v1/config",
      configAK: "gNShJPNcOlv0A4bbQ3EqJbf52ukCM6lV",
      routingKey: "",
      routingUpdateKey: "prod",
      authRoutingKey: "",
      manifestPath:
        "https://onlinebanking.usbank.com/auth/login/wmf/latest/manifest.json",
      manifestPathTimeout:
        "https://onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
      manifestPathLoginHelp:
        "https://onlinebanking.usbank.com/digital/loginhelp/wmf/latest/manifest.json",
    };
  }

  return defaultEndpoints;
};

// eslint-disable-next-line import/prefer-default-export
export const endpoints = setEndpointURLs();
